<template>
  <!-- begin:: Page -->
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <top-navbar></top-navbar>

    <!-- begin::Body -->
    <div
      class="m-grid__item m-grid__item--fluid  m-grid m-grid--ver-desktop m-grid--desktop 	m-container m-container--responsive m-container--xxl m-page__container m-body">

      <div id="m_aside_left" class="m-grid__item m-aside-left ">
        <!-- BEGIN: Left Aside -->

        <slot name="sidebar"
              :category="category"
              :filter-node="filterNode"
        ></slot>
      </div>

      <!-- END: Left Aside -->

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <!-- BEGIN: Subheader -->

        <div class="m-subheader ">
          <div class="d-flex align-items-center">
            <div class="mr-auto">
              <h3 class="m-subheader__title m-subheader__title--separator">
                <slot name="subheader"></slot>
              </h3>
            </div>
          </div>
        </div>

        <!-- END: Subheader -->
        <slot></slot>
      </div>
    </div>

    <!-- begin::Footer -->
    <footer class="m-grid__item m-footer ">
      <!-- <div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
        <div class="m-footer__wrapper">
          <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
            <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
								<span class="m-footer__copyright">
									2017 &copy; Metronic theme by <a href="https://keenthemes.com" class="m-link">Keenthemes</a>
								</span>
            </div>
            <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
              <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
                <li class="m-nav__item">
                  <a href="#" class="m-nav__link">
                    <span class="m-nav__link-text">About</span>
                  </a>
                </li>
                <li class="m-nav__item">
                  <a href="#" class="m-nav__link">
                    <span class="m-nav__link-text">Privacy</span>
                  </a>
                </li>
                <li class="m-nav__item">
                  <a href="#" class="m-nav__link">
                    <span class="m-nav__link-text">T&C</span>
                  </a>
                </li>
                <li class="m-nav__item">
                  <a href="#" class="m-nav__link">
                    <span class="m-nav__link-text">Purchase</span>
                  </a>
                </li>
                <li class="m-nav__item m-nav__item--last">
                  <a href="#" class="m-nav__link" data-toggle="m-tooltip" title="Support Center"
                     data-placement="left">
                    <i class="m-nav__link-icon flaticon-info m--icon-font-size-lg3"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->
    </footer>

    <!-- end::Footer -->

  </div>
  <!-- end:: Page -->
</template>
<script>
import TopNavbar from '@/pages/Layout/TopNavbar.vue'
import Menu from 'menu'

export default {
  components: {
    TopNavbar,
  },
  props: ['category', 'filterNode'],
  data () {
    return {
      filterText :'',
      menus: Menu,
    }
  },
}

</script>
<style lang="scss">
  .m-subheader .m-subheader__title {
    font-family: 'Nanum Gothic', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Layout/Default.vue